var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequestsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "20px",
  viewBox: "0 0 21 20",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "7.78173312e-05 0.547 20.248 0.547 20.248 18.9999866 7.78173312e-05 18.9999866"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Requests",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Navigation-bar-",
  transform: "translate(-221.000000, -712.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(221.000000, 712.452900)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5623,12.5218 L18.8433,2.9178 L18.8483,16.0328 L9.5623,12.5218 Z M8.8143,17.0298 L8.8143,13.7358 L10.4423,14.3508 L8.8143,17.0298 Z M1.1533,9.6148 L1.1533,9.6148 L0.9733,9.2088 L1.1533,9.6148 Z M1.8263,9.5968 L16.8793,2.9348 L8.1363,11.9828 L1.8263,9.5968 Z M20.2423,1.6958 C20.2443,1.3598 20.0883,1.0528 19.8703,0.8578 C19.6523,0.6588 19.3713,0.5478 19.0683,0.5468 C18.9073,0.5468 18.7413,0.5808 18.5853,0.6488 L0.6903,8.5688 L0.6903,8.5688 L0.6903,8.5688 C0.2563,8.7528 -0.0087,9.1968 0.0003,9.6148 C-0.0087,10.0558 0.2833,10.5168 0.7503,10.6868 L7.4143,13.2058 L7.4143,17.8508 C7.4093,18.1938 7.5763,18.5188 7.8053,18.7098 C8.0343,18.9048 8.3083,18.9988 8.5933,18.9998 C8.9513,19.0068 9.3703,18.8168 9.5963,18.4388 L11.7453,14.9028 C11.7553,14.8868 11.7553,14.8678 11.7633,14.8508 L18.6513,17.4558 C18.7903,17.5078 18.9343,17.5328 19.0753,17.5328 C19.3793,17.5318 19.6623,17.4198 19.8793,17.2208 C20.0973,17.0238 20.2503,16.7188 20.2483194,16.3838 L20.2423,1.6958 Z",
  id: "Fill-1",
  fill: "#6467EF",
  mask: "url(#mask-2)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequestsIcon);
export default ForwardRef;